import { paths } from '~/lib/paths'
import { ModelApiKey } from '~/types/models'

/**
 * Returns the localized path based on records _modelApiKey and slug
 *
 * @returns {string} path
 */
export default function useLocalePathByType(modelApiKey: string, slug: string): string | undefined {
  const { locale } = useI18n()
  const localePath = useLocalePath()

  let path: string | undefined
  switch (modelApiKey) {
    case 'index':
      path = localePath('/')
      break
    case 'page':
      path = localePath(`/${slug}`)
      break
    case 'project':
      path = localePath(`/${paths[locale.value][ModelApiKey.Project].path}/${slug}`)
      break
    case 'article':
      path = localePath(`/${paths[locale.value][ModelApiKey.Article].path}/${slug}`)
      break
    case 'location':
      path = localePath(`/${paths[locale.value][ModelApiKey.Location].path}/${slug}`)
      break
    default:
      console.warn(`No path found for ${modelApiKey} model`)
  }

  return path
}
